module.exports = __webpack_public_path__ + "img/about_img.49ffd812.png";